const bttxtwrap = document.querySelector('.read-more-btn-hc');
const readtxtwrap = document.querySelector('.read-more-sliced');
const mmwholetxt = document.querySelector('.hc-whole-text');

if(bttxtwrap){
  bttxtwrap.addEventListener('click', event => {
    readtxtwrap.style.display = "none";
    mmwholetxt.style.display = "block";  
  });
}

const collectionFaqs = document.querySelector('.collection__faqs');
if (collectionFaqs){
  bttxtwrap.addEventListener('click', ()=>{
    collectionFaqs.classList.remove('display-one-desktop');
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Select all product images with hover image data
  document.querySelectorAll('.grid-product__image').forEach(function (image) {
    const hoverImageUrl = image.getAttribute('data-hover-image');
    const originalImageUrl = image.getAttribute('data-src');
    
    // If hover image URL is available, add the hover effect
    if (hoverImageUrl) {
      image.addEventListener('mouseenter', function () {
        image.setAttribute('src', hoverImageUrl);  // Set hover image on mouse enter
      });

      image.addEventListener('mouseleave', function () {
        image.setAttribute('src', originalImageUrl);  // Revert to original image on mouse leave
      });
    }
  });
});




  
